<template>
  <el-drawer v-model="visible" :size="480" :title="title" @closed="handleClose">
    <div class="p-relative h-full">
      <el-tabs v-if="isExhibition" v-model="activeChannel">
        <el-tab-pane
          v-for="item in channelList"
          :key="item.name"
          :disabled="loading && item.name !== activeChannel"
          :label="item.label"
          :name="item.name"
        />
      </el-tabs>
      <el-image v-loading="loading" fit="contain" :src="imgUrl" style="width: 100%; height: 70vh" />
      <div class="p-absolute b-0 d-flex flex-center w-full">
        <el-button :disabled="loading" size="large" type="primary" @click="downloadImageByUrl(imgUrl, filename)">
          下载图片
        </el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script setup>
  import { isFunction, isObject, noop } from 'lodash'
  import { ref, defineExpose, watch, computed } from 'vue'
  import { downloadImageByUrl, imageUrl2Base64 } from '@/utils/download'
  import { useToggle } from '@/hooks/useToggle'

  const CHANNEL_ENUMS = {
    REGISTER: 'REGISTER',
    HOME: 'HOME',
  }
  const CHANNEL_CN_ENUMS = {
    REGISTER: '注册',
    HOME: '首页',
  }
  let channelNo = ''
  const { value: visible, toggle: toggleVisible } = useToggle()
  const { value: loading, toggle: toggleLoading } = useToggle()
  const title = ref('')
  const imgUrl = ref('')
  const isExhibition = ref(false)
  const activeChannel = ref(CHANNEL_ENUMS.REGISTER)
  const channelList = ref(
    [CHANNEL_ENUMS.REGISTER, CHANNEL_ENUMS.HOME].map((name) => ({
      name,
      label: CHANNEL_CN_ENUMS[name] + '渠道',
    }))
  )
  const imgCached = new Map()
  const filename = computed(() => `${title.value}_${CHANNEL_CN_ENUMS[activeChannel.value]}`)

  let fetchImage = noop
  function setLoader(loadImage) {
    ;(fetchImage = async (key = 'REGISTER') => {
      key = `${channelNo}_${key}`
      if (imgCached.has(key)) {
        imgUrl.value = imgCached.get(key)
      } else {
        toggleLoading()
        imgUrl.value = ''
        const url = await loadImage(key)
        imgCached.set(key, (imgUrl.value = await imageUrl2Base64(url)))
        toggleLoading()
      }
    })()
  }

  let destroyWatcher = noop

  async function open(opt) {
    if (!isObject(opt)) throw new Error('请传入正确的参数')
    channelNo = opt.channelNo
    if (isFunction(opt.loadImage)) setLoader(opt.loadImage)
    title.value = opt.title
    isExhibition.value = opt.isExhibition
    toggleVisible()
    destroyWatcher = watch(activeChannel, (val) => fetchImage(val))
  }

  function handleClose() {
    destroyWatcher()
    activeChannel.value = CHANNEL_ENUMS.REGISTER
    imgUrl.value = ''
  }

  defineExpose({
    open,
  })
</script>

<style lang="scss" scoped></style>
